<template>
  <el-alert
    v-if="visible"
    :title="title"
    :type="type"
    :description="defaultDescription"
    :show-icon="showIcon"
    :closable="closable"
    :center="center"
  >
  </el-alert>
</template>
<script>
export default {
  name: 'BjAlert',
  props: {
    title: {
      type: String,
      default: '提示',
    },
    type: {
      type: String,
      default: 'warning',
    },
    description: {
      type: String,
      default: '内容',
    },
    closable: {
      type: Boolean,
      default: false,
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    duration: {
      type: Number,
      default: 4500,
    },
    center: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      descriptionText: '',
    };
  },
  computed: {
    defaultDescription() {
      return this.descriptionText || this.description;
    },
  },
  methods: {
    show(description) {
      this.descriptionText = description;
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
  },
};
</script>
